module.exports = __webpack_public_path__ + "static/media/occupation.1199c43f.png";